import { SortClockDescendingIcon } from './SortClockDescendingIcon';

/**
 * author: Michael Irigoyen
 * id 8064DE58-939A-4179-A65E-0F5FA4AD6A18
 * name sort-clock-descending
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-clock-descending.svg
 * tags
 * - Text / Content / Format 
 * - Date / Time 
 */
export const SortTimeDescendingIcon = SortClockDescendingIcon;
export default SortTimeDescendingIcon